import React from 'react';
import { cx } from '@emotion/css';

import { StyleLibrary } from '../../../vm-omega-shared-component-webapp';

type Props = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export const CtaButton: React.FC<Props> = props => {
  return (
    <button {...props} className={cx(StyleLibrary.ComponentStyles.ButtonStyles.primaryButton, props.className)}>
      {props.children}
    </button>
  );
};
